export default __webpack_public_path__ + "static/media/image-blank.aa781043.svg";